import { createContext, useEffect, useState } from "react";
import { ReadAll } from "services/feature-flags";

export const FeatureFlagsContext = createContext({});

export const FlagsState = ({ children }) => {
  const [flags, setFlags] = useState({});

  const fetchFlags = async () => {
    try {
      const response = await ReadAll();

      const data = response?.data?.map(flag => flag.attributes
      ) || [];

      const featureFlags = data.reduce((acc, flag) => {
        acc[flag.name] = flag.enabled;
        return acc;
      }, {});

      setFlags(featureFlags);

    } catch (error) {
      console.error("Error fetching flags:", error);
    }
  };

  useEffect(() => {
    fetchFlags();
  }, [])

  const isFeatureEnabled = (feature) => {
    if (flags[feature] || flags[feature] === undefined) {
      return true;
    }
    return false;
  }

  const contextValue = {
    flags,
    isFeatureEnabled
  };

  return (
    <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>
  );
};
